import angular from 'angular';
import {
  userService,
  loaderService,
  ssDialogService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon,
  editControlTypeDialog,
} from 'app/components/global';
import controller from './control-main.controller';
import directive from './control-main.directive';
import bulkDeleteControlsDialog from '../dialog.bulkDeleteControlsDialog';
import syncControlTypeDialog from '../dialog.syncControlType';


const controlMainAdminModule = angular.module('app.components.admin.controlMain', [
  userService,
  alerts,
  actionIcon,
  confirmDialog,
  editControlTypeDialog,
  loaderService,
  ssDialogService,
  controlDataService,
  controlSharedModelService,
  bulkDeleteControlsDialog,
  syncControlTypeDialog
])
  .directive('controlMain', directive)
  .controller('ControlMainController', controller);

export default controlMainAdminModule.name;

console.log('app.components.admin.controlMain created');
